import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntuitiveIndication } from '../../models';
import { TranslateModule } from '@ngx-translate/core';
import { RxIntuitiveIndicationButtonsComponent } from '../rx-intuitive-indication-buttons/rx-intuitive-indication-buttons.component';
import { RxIntuitiveRemoveFromBridgeButtonComponent } from '../rx-intuitive-remove-from-bridge-button/rx-intuitive-remove-from-bridge-button.component';

@Component({
	selector: 'rx-intuitive-bridge-indication-buttons',
	templateUrl: './rx-intuitive-bridge-indication-buttons.component.html',
	styleUrls: ['./rx-intuitive-bridge-indication-buttons.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule, RxIntuitiveIndicationButtonsComponent, RxIntuitiveRemoveFromBridgeButtonComponent]
})
export class RxIntuitiveBridgeIndicationButtonsComponent {
	@Input() indicationIds: IntuitiveIndication[] = [];
	@Input() selectedIndicationIds: IntuitiveIndication[] = [];
	@Input() enabledIndicationIds: IntuitiveIndication[] = [];
	@Input() disabled = false;
	@Input() asLabel = false;

	@Input() canRemove = false;

	@Output() indicationSelected = new EventEmitter<IntuitiveIndication>();
	@Output() removeFromBridge = new EventEmitter<void>();

	onRemoveFromBridge(): void {
		if (!this.canRemove) {
			return;
		}

		this.removeFromBridge.emit();
	}
}
